import { useAuthentication, EXTERNAL_LINKS } from '@psyomics/ui-common';
import { AccountPage, GenericError, LoadingSpinner, PageLink } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useGetServiceUserQuery } from '../hooks/use-get-service-user-query';

const Account = () => {
  const { logout } = useAuthentication();
  const [serviceUser, fetching] = useGetServiceUserQuery();
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (fetching) return <LoadingSpinner />;

  if (!serviceUser) return <GenericError titleKey={'page.account.userNotFound'} />;

  return (
    <AccountPage
      changePassword={{
        onClick: () => navigate('/account/change-password'),
        text: t('page.account.changePassword'),
      }}
      onBack={() => navigate('/')}
      onSignOut={logout}
      signOutText={t('page.account.signOut')}
      title={t('page.account.title')}
      username={serviceUser.username}
    >
      <PageLink text={t('page.account.termsLink')} to={EXTERNAL_LINKS.TERMS_OF_USE} />
      <PageLink text={t('page.account.privacyLink')} to={EXTERNAL_LINKS.PRIVACY_POLICY} />
    </AccountPage>
  );
};

export { Account };
